import { mapActions } from 'vuex';

// eslint-disable-next-line
export const checkAuth = {
  methods: {
    ...mapActions({
      getDealer: 'users/getDealer',
    }),
  },
  created() {
    const store = JSON.parse(localStorage.getItem('store'));

    if (store) {
      this.getDealer(store.user.principal.id);
    }
  },
};
